import { render, staticRenderFns } from "./CecUnmUserSetsMealProjectDet.vue?vue&type=template&id=45b5cc56&scoped=true"
import script from "./CecUnmUserSetsMealProjectDet.vue?vue&type=script&lang=js"
export * from "./CecUnmUserSetsMealProjectDet.vue?vue&type=script&lang=js"
import style0 from "./CecUnmUserSetsMealProjectDet.vue?vue&type=style&index=0&id=45b5cc56&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b5cc56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45b5cc56')) {
      api.createRecord('45b5cc56', component.options)
    } else {
      api.reload('45b5cc56', component.options)
    }
    module.hot.accept("./CecUnmUserSetsMealProjectDet.vue?vue&type=template&id=45b5cc56&scoped=true", function () {
      api.rerender('45b5cc56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/cecunmusersetmeal/CecUnmUserSetsMealProjectDet.vue"
export default component.exports